import { MaskedLines, Reveal } from "./Reveal";

export const PageHero = ({ eyebrow, lines, intro, children, testId = "page-hero" }) => (
  <section className="relative bg-[var(--navy)] text-white grain overflow-hidden" data-testid={testId}>
    <div className="absolute -right-32 -top-32 h-96 w-96 rounded-full border border-white/10" aria-hidden="true" />
    <div className="absolute -right-10 top-24 h-64 w-64 rounded-full border border-white/5" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-6 lg:px-10 pt-20 pb-20 md:pt-28 md:pb-24">
      <Reveal><p className="eyebrow text-[var(--green-bright)] mb-6">{eyebrow}</p></Reveal>
      <MaskedLines lines={lines} testId={`${testId}-title`}
        className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.04] max-w-4xl" />
      {intro && (
        <Reveal delay={0.35}>
          <p className="mt-7 max-w-2xl text-base md:text-lg leading-relaxed text-slate-300">{intro}</p>
        </Reveal>
      )}
      {children}
    </div>
  </section>
);
